import React from "react";

const isStaging = process.env.REACT_APP_ENVIRONMENT === "staging";

const StagingBanner = () => {
  if (!isStaging) return null;

  return (
    <div className="w-full bg-amber-400 text-amber-900 text-sm px-4 py-2 flex items-center justify-center gap-2 font-medium">
      <span>⚠️</span>
      <span>
        <strong>STAGING</strong> — Test environment. DB syncs nightly from prod at 3:00 AM.
        Emails, crons and AI-scoring are disabled.
      </span>
    </div>
  );
};

export default StagingBanner;
